import React from 'react';

const JS_Hoisting = () => {
  return (
    <div >
      <h1>JS_Hoisting</h1>
      <p>Placeholder component for: "JS Hoisting"</p>
    </div>
  );
};

export default JS_Hoisting;
